
/* System defined core library */
import { Component, OnInit, Output, OnDestroy, EventEmitter, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

/* User defined library/components */
import { SelectedExamDetailService } from '../../../shared/services/selected-exam-detail.service';
import { SchedulingApiService } from '../../../shared/services/scheduling-api.service';

/* User defined models */
import { TextReminder } from '../../../../shared/models/scheduling/textReminder.model';
import { Exam } from '../../../../shared/models/scheduling/exam.model';
import { Country } from '../../../../shared/models/scheduling/country.model';
import { Hold } from '../../../../shared/models/scheduling/hold.model';


@Component({
    selector: 'app-text-reminder',
    templateUrl: './text-reminder.component.html',
    styleUrls: ['./text-reminder.component.scss']
})
export class TextReminderComponent implements OnInit, OnChanges {

    /* User defined private/public variables  */
    public selectedCountryISDCode: string;
    public chkConfirmMsgBoxChecked: boolean = false;
    public txtReminderFrm: FormGroup;
    public selectedTextReminder: TextReminder;
    public countries: Country[];


    /* Input-OutPut parameters decalartions */
    @Output() isTextReminderChanged: EventEmitter<TextReminder> = new EventEmitter();

    /* Service subscriptions */
    exam$: Subscription;
    translateLanguage$: Subscription;

    /* Constructor declaration with required injected services */
    constructor(
        private schedulingApiService: SchedulingApiService,
        private selectedExamDetailService: SelectedExamDetailService,
        private fb: FormBuilder,
        private translate: TranslateService
    ) {
        this.getCountries();
        this.selectedTextReminder = new TextReminder();
        translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
        this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
            languageCode => {
                translate.use(languageCode);
            }
        );
    }

    /* Initialize the component & call require methods when component loaded first time. */
    ngOnInit() {
        this.txtReminderFrm = this.fb.group({
            'confirmMsg': new FormControl('', null),
            'selectCountry': new FormControl('', Validators.required),
            'mobileNumber': new FormControl('', [Validators.required, Validators.pattern('[0-9]*')])
        });

        this.selectedCountryISDCode = "";
        this.txtReminderFrm.get('confirmMsg').valueChanges.subscribe(
            value => this.updateRequiredFieldValidators(value)
        );
    }

    /* Get countries from API */
    getCountries() {
        this.schedulingApiService.getCountries().subscribe(
            countries => { this.countries = countries }
        );

    }

    /* Emit the mobile number is entered & checkbox is checked */
    ngOnChanges() {
        if (this.chkConfirmMsgBoxChecked) {
            this.selectedExamDetailService.setReminder(this.selectedTextReminder);
            this.isTextReminderChanged.emit(this.selectedTextReminder);
        }
    }

    onCheckBoxchange(event: any): void {
        if (event.target != null && event.target != undefined) {
            this.chkConfirmMsgBoxChecked = (event.target.checked) ? true : false;
            this.selectedTextReminder.isNotificationSelected = this.chkConfirmMsgBoxChecked;
        }

        this.selectedExamDetailService.setReminder(this.selectedTextReminder);
        this.isTextReminderChanged.emit(this.selectedTextReminder);

    }


    /* Emitter if user changes the mobile number */
    onBlurReminderControl(event: any): void {
        if (this.chkConfirmMsgBoxChecked && this.txtReminderFrm.valid) {
            this.selectedExamDetailService.setReminder(this.selectedTextReminder);
        }
        this.isTextReminderChanged.emit(this.selectedTextReminder);

    }

    /* Show ISD code on change of country */
    changeCountry(country: Country) {
        this.selectedTextReminder.country = country;
        this.selectedTextReminder.countryISDCode = country.phonePrefix;
        this.selectedCountryISDCode = country.phonePrefix;
        if (this.chkConfirmMsgBoxChecked) {
            this.selectedExamDetailService.setReminder(this.selectedTextReminder);
            this.isTextReminderChanged.emit(this.selectedTextReminder);
        }
    }

    /* Set validations */
    updateRequiredFieldValidators(value: boolean): void {
        if (value) {
            this.chkConfirmMsgBoxChecked = true;
            this.txtReminderFrm.get('selectCountry').setValidators(Validators.required);
            this.txtReminderFrm.get('mobileNumber').setValidators([Validators.required, Validators.pattern('[0-9]*')]);
        }
        else {
            this.chkConfirmMsgBoxChecked = false;
            this.txtReminderFrm.get('selectCountry').clearValidators();
            this.txtReminderFrm.get('mobileNumber').clearValidators();
        }
        this.txtReminderFrm.get('selectCountry').updateValueAndValidity();
        this.txtReminderFrm.get('mobileNumber').updateValueAndValidity();
    }
}
